// extracted by mini-css-extract-plugin
module.exports = {"small":"MushroomIcon_small__qYSlj","default":"MushroomIcon_default__1Cq4t"};